import { truckTypes } from '../../utils/truckTypes'
import { REQUEST, SUCCESS, ERROR } from './types'

const state = {
  data: [],
  loading: false,
  error: false
}

const getters = {
  isLoading: state => state.loading,
  isError: state => state.error,
  vehiclesList: state => state.data.map(item => ({
    ...item,
    truckType: `${
      truckTypes.find(type => type.value === item.type).description
    }`
  })),
  vehicleType: state => id => state.data.find(type => type._id === id)
}

const actions = {
  async get ({ commit, dispatch }) {
    commit(REQUEST)

    const { data } = await dispatch(
      `api`,
      {
        entity: `typevehicles`,
        action: `get`
      },
      { root: true }
    )

    if (data) {
      commit(SUCCESS, data)
    } else {
      commit(ERROR)
    }
  }
}

const mutations = {
  [REQUEST] (state) {
    state.loading = true
  },
  [SUCCESS] (state, payload) {
    state.data = payload
    state.loading = false
    state.error = false
  },
  [ERROR] () {
    state.error = true
    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
